import { render, staticRenderFns } from "./FormArticleUpload.vue?vue&type=template&id=1337b697&scoped=true&"
import script from "./FormArticleUpload.vue?vue&type=script&lang=js&"
export * from "./FormArticleUpload.vue?vue&type=script&lang=js&"
import style0 from "./FormArticleUpload.vue?vue&type=style&index=0&id=1337b697&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1337b697",
  null
  
)

export default component.exports